import { getPointResolution } from "ol/proj";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const dims = {
  // ancho, altura
  a0: [1189, 841],
  a1: [841, 594],
  a2: [594, 420],
  a3: [420, 297],
  a4: [297, 210],
  a5: [210, 148],
};

const exportOptions = {
  useCORS: true,
  ignoreElements: function (element) {
    const className = element.className || "";
    return (
      className.includes("ol-control") &&
      !className.includes("ol-scale") &&
      (!className.includes("ol-attribution") ||
        !className.includes("ol-uncollapsible"))
    );
  },
};

const exportButton = document.getElementById("export-pdf");

export const imprimir = (map, scaleLine) => {
  exportButton.addEventListener(
    "click",
    function () {
      var scale1 = document.querySelector(".ol-scale-text").innerHTML;
      let scaleNumber = scale1.split(":")[1];

      console.log(scaleNumber);

      if (scaleNumber.includes(",")) {
        scaleNumber = parseInt(scaleNumber.replace(/\,/g, "") / 1000);
      } else {
        scaleNumber = parseInt(scaleNumber.replace(/\./g, "") / 1000);
      }

      const scale2 = parseInt(
        document
          .querySelector(".ol-scale-text")
          .innerHTML.split(":")[1]
          .replace(/\,/g, "") / 1000
      );

      console.log("escala", scale2);

      let titulo = document.getElementById("titulo").value;
      let posicion = document.getElementById("posicion").value;
      let images = document.querySelectorAll(
        ".capas-activas-panel-leyenda img"
      );

      exportButton.disabled = true;
      document.body.style.cursor = "progress";
      //const format = document.getElementById('format').value;
      const format = "a4";
      //const resolution = document.getElementById('resolution').value;
      const resolution = "200";

      const dim = dims[format];

      let width;
      let height;
      let pdf;
      let yPos;
      let xPos;

      if (posicion == "portrait") {
        width = Math.round((dim[1] * resolution) / 25.4);
        height = Math.round((dim[0] * resolution) / 25.4);
        pdf = new jsPDF("portrait", undefined, format);
      } else {
        width = Math.round((dim[0] * resolution) / 25.4);
        height = Math.round((dim[1] * resolution) / 25.4);
        pdf = new jsPDF("landscape", undefined, format);
      }

      const viewResolution = map.getView().getResolution();

      const scaleResolution =
        scaleNumber /
        getPointResolution(
          map.getView().getProjection(),
          resolution / 25.4,
          map.getView().getCenter()
        );

      map.once("rendercomplete", function () {
        exportOptions.width = width;
        exportOptions.height = height;

        html2canvas(map.getViewport(), exportOptions).then(function (canvas) {
          const inicioIzqMapa = 5;
          const inicioAlturaMapa = 20;

          // (empieza desde izquierda,empieza desde arriba,ancho,largo)
          pdf.text(titulo, 5, 15);
          //pdf.addImage('./assets/dep_logo.png','PNG',150,5,55,9)
          const imageUrl = "./dep_logo.png";

          if (posicion == "portrait") {
            pdf.addImage(imageUrl, "PNG", 140, 5, 60, 11);

            pdf.addImage(
              canvas.toDataURL("image/jpeg"),
              "JPEG",
              inicioIzqMapa,
              inicioAlturaMapa,
              dim[1] - inicioIzqMapa * 2,
              dim[0] - (inicioAlturaMapa * 2) / 1.5
            );

            pdf.setDrawColor(0, 0, 0); // Set line color to black (default)
            pdf.setLineWidth(0.5); // Set line width to 0.5
            pdf.rect(
              inicioIzqMapa, // X position of the rectangle
              inicioAlturaMapa, // Y position of the rectangle
              dim[1] - inicioIzqMapa * 2, // Width of the rectangle (same as image width)
              dim[0] - (inicioAlturaMapa * 2) / 1.5 // Height of the rectangle (same as image height)
            );
            yPos = 250; // Start Y position for the first image
            xPos = 170;
          } else {
            pdf.addImage(imageUrl, "PNG", 210, 5, 60, 11);

            pdf.addImage(
              canvas.toDataURL("image/jpeg"),
              "JPEG",
              inicioIzqMapa,
              inicioAlturaMapa,
              dim[0] - inicioIzqMapa * 2,
              dim[1] - (inicioAlturaMapa * 2) / 1.5
            );

            pdf.setDrawColor(0, 0, 0); // Set line color to black (default)
            pdf.setLineWidth(0.5); // Set line width to 0.5
            pdf.rect(
              inicioIzqMapa, // X position of the rectangle
              inicioAlturaMapa, // Y position of the rectangle
              dim[0] - inicioIzqMapa * 2, // Width of the rectangle (same as image width)
              dim[1] - (inicioAlturaMapa * 2) / 1.5 // Height of the rectangle (same as image height)
            );
            yPos = 170; // Start Y position for the first image
            xPos = 240;
          }

          images.forEach((element) => {
            let imgWidthPx = element.naturalWidth;
            let imgHeightPx = element.naturalHeight;

            // Convert pixels to mm (assuming 96 PPI)
            let imgWidthMm = (imgWidthPx / 96) * 25.4;
            let imgHeightMm = (imgHeightPx / 96) * 25.4;

            pdf.addImage(
              element.src,
              "PNG",
              xPos,
              yPos,
              imgWidthMm,
              imgHeightMm
            );

            yPos -= imgHeightMm + 2; // Adding 10 mm for spacing between images
          });

          // Reset original map size
          pdf.save("map.pdf");
          scaleLine.setDpi();

          map.getTargetElement().style.width = "";
          map.getTargetElement().style.height = "";
          map.updateSize();
          map.getView().setResolution(viewResolution);

          exportButton.disabled = false;
          document.body.style.cursor = "auto";
        });
      });

      // Set print size
      scaleLine.setDpi(resolution);
      map.getTargetElement().style.width = width + "px";
      map.getTargetElement().style.height = height + "px";
      map.updateSize();
      map.getView().setResolution(scaleResolution);
    },
    false
  );
};
